import { FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import 'reflect-metadata';

import { CLASS_VALIDATOR_METADATA_KEY } from './class-validator-config';

const FORM_CONTROL_METADATA_KEY = Symbol('formControlMetadata');


interface FormControlConfig {
  defaultValue?: any;
  validators?: ValidatorFn[];
  array?: boolean;  // 配列を明示的に指定するためのプロパティ

  /**
   * codeMaster==trueの場合に、checkbox=trueとすることでチェックボックスのグループFormを作成する。
   */
  checkbox?: boolean;

}

function FormControlConfig(config: FormControlConfig) {
  return function (target: any, propertyKey: string) {
    const existingMetadata = Reflect.getMetadata(FORM_CONTROL_METADATA_KEY, target.constructor) || {};
    existingMetadata[propertyKey] = config;
    Reflect.defineMetadata(FORM_CONTROL_METADATA_KEY, existingMetadata, target.constructor);
  };
}
export { FORM_CONTROL_METADATA_KEY, FormControlConfig };


export function ClassValidator(...validators: ValidatorFn[]) {
  return function (constructor: Function) {
    const existingValidators: ValidatorFn[] = Reflect.getMetadata(CLASS_VALIDATOR_METADATA_KEY, constructor) || [];
    Reflect.defineMetadata(CLASS_VALIDATOR_METADATA_KEY, [...existingValidators, ...validators], constructor);
  };
}

export class FormBuilderService {

  static buildForm(fb: FormBuilder, instance: any): FormGroup {
    const formControls: any = {};
    const metadata = Reflect.getMetadata(FORM_CONTROL_METADATA_KEY, instance.constructor) || {};

    for (const key of Object.keys(metadata)) {
      const config = metadata[key];
      const controlValue = config.defaultValue || null;
      const control = new FormControl(config.defaultValue || null, config.validators || []);
      console.log(key, control)

      // `array` プロパティが設定されていればFormArrayを作成
      if (config.array) {
        formControls[key] = fb.array([]);
      } else {
        // 通常のFormControlを作成
        formControls[key] = new FormControl(controlValue, config.validators || []);
      }
    }

    const formGroup = fb.group(formControls);

    // クラスレベルのバリデーターを適用
    const classValidators: ValidatorFn[] = Reflect.getMetadata(CLASS_VALIDATOR_METADATA_KEY, instance.constructor) || [];
    formGroup.setValidators(classValidators);

    return formGroup;
  }

}
